import apiClient from "@/services/api-client";
import { useQuery } from "@tanstack/react-query";
import { errorLogger } from "@/utils/helpers/logger";

const fetchWishListInfo = async () => {
  return await apiClient({
    method: "POST",
    url: "/v1/wishlist",
  });
};

export const useFetchWishListInfo = (useQueryOptions) => {
  return useQuery({
    queryKey: ["wishlist"],
    queryFn: fetchWishListInfo,
    ...useQueryOptions,
    select: (data) => {
      let apiData = data.data?.data;
      return apiData?.wishlist;
    },
    onError: (error) => {
      errorLogger.logApiError(error);
    },
    initialData: [],
  });
};
